import * as React from 'react';
import { ISuburbanMortgageDataOptions } from '../../types/suburban/data';
import { toNumberPrecision } from '../../utils/formatNumber/toNumberPrecision';
import styles from './styles.css';

interface IProps {
  options: ISuburbanMortgageDataOptions;
  exactRate?: boolean;
}

const formatNumber = (num: number) => toNumberPrecision(num, 2);
const formatRate = (rate: number) => `${formatNumber(rate * 100)}%`;

const formatMortgageData = (
  data: ISuburbanMortgageDataOptions,
  exactRate: boolean,
): Record<keyof ISuburbanMortgageDataOptions, string> => {
  return {
    rate: `${!exactRate ? 'от ' : ''}${formatRate(data.rate)}*`,
    creditLimitMillions: `до ${formatNumber(data.creditLimitMillions)} млн ₽`,
    termMonths: `до ${Math.floor(data.termMonths / 12)} лет`,
    initialPaymentMinRate: `от ${formatRate(data.initialPaymentMinRate)}`,
  };
};

export const SuburbanMortgageAdvantages: React.FC<IProps> = ({ options, exactRate = false }) => {
  const { initialPaymentMinRate, termMonths, rate, creditLimitMillions } = formatMortgageData(options, exactRate);

  return (
    <div className={styles['advantages']}>
      <div className={styles['advantage']}>
        <h4 className={styles['title']}>{rate}</h4>
        <p className={styles['sub-title']}>Процентная ставка</p>
      </div>
      <div className={styles['advantage']}>
        <h4 className={styles['title']}>{creditLimitMillions}</h4>
        <p className={styles['sub-title']}>Сумма кредита</p>
      </div>
      <div className={styles['advantage']}>
        <h4 className={styles['title']}>{termMonths}</h4>
        <p className={styles['sub-title']}>Срок кредита</p>
      </div>
      <div className={styles['advantage']}>
        <h4 className={styles['title']}>{initialPaymentMinRate}</h4>
        <p className={styles['sub-title']}>Первоначальный взнос</p>
      </div>
    </div>
  );
};
